import { ConfirmationDialog } from "@/components/modal/ConfirmationDialog";

export function RosterSaveConfirmDialog(props: {
  readonly open: boolean;
  readonly isPending: boolean;
  readonly onClose: () => void;
  readonly onConfirm: () => void;
}) {
  return (
    <ConfirmationDialog
      {...props}
      heading="근무표 저장"
      confirmText="저장"
      title="근무표를 저장하시겠습니까?"
      pendingText="저장 중..."
    />
  );
}
